import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess,
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import Vue from 'vue'
import SendMail from '@/components/common/SendMail'
import PickList from '@/components/modules/orders/PickList'
import LoadingList from '@/components/modules/orders/LoadingList'
import SupplyManagement from '@/components/modules/orders/SupplyManagement'
import SaleorderTabs from '@/components/modules/orders/SaleorderTabs'
import OrdersPrint from '@/components/modules/orders/settings/OrdersPrint'
import OrdersOther from '@/components/modules/orders/settings/OrdersOther'
import SaleOrderProcess from '@/components/modules/orders/SaleOrderProcess'
import PurchaseOrderProcess from '@/components/modules/orders/PurchaseOrderProcess'
import SaleordersSettings from '@/components/modules/orders/settings/SaleordersSettings'
import PurchaseordersSettings from '@/components/modules/orders/settings/PurchaseordersSettings'
import PickListSettings from '@/components/modules/orders/settings/PickListSettings'
export const orders = [
	{
		path: '/purchaseorders',
		redirect: '/orders/purchaseorders'
	},
	{
		path: '/orders/', 
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/orders/',
					text: 'saleorders',
					model: 'saleorder'
				},
				{
					to: '/orders/purchaseorders',
					text: 'Ordini di Acquisto',
					model: 'purchaseorder'
				},
				{
					to: '/orders/picklist',
					text: 'Lista di prelievo',
					model: 'saleorder'
				},
				{
					to: '/orders/loadinglist',
					text: 'Lista di carico',
					model: 'purchaseorder'
				},
				{
					to: '/orders/supplymanagement',
					text: 'Approvvigionamenti',
					model: 'saleorder'
				},
			],
		},
		children: [
			{
				path: '/orders/',
				name: 'saleorders-index',
				beforeEnter: (to, from, next) => canAccess('permission', 'saleorder', next),
				component: Crud,
				meta: {
					title: trans('saleorders')
				},
				props: {
					modelDef: 'saleorders',
					actionIcon: 'assignment',
					title: 'saleorders',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/orders/purchaseorders',
				name: 'purchaseorders-index',
				beforeEnter: (to, from, next) => canAccess('permission', 'purchaseorder', next),
				component: Crud,
				meta: {
					title: trans('purchaseorders')
				},
				props: {
					modelDef: 'purchaseorders',
					actionIcon: 'assignment',
					title: 'Ordini di Acquisto',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/orders/picklist',
				beforeEnter: (to, from, next) => canAccess('permission', 'saleorder', next),
				component: PickList,
				meta: {
					title: trans('picklist')
				},
				props: {
					modelDef: 'saleorders',
					actionIcon: 'assignment',
					title: 'Lista di prelievo'
				}
			},
			{
				path: '/orders/loadinglist',
				beforeEnter: (to, from, next) => canAccess('permission', 'purchaseorder', next),
				component: LoadingList,
				meta: {
					title: trans('loadinglist')
				},
				props: {
					modelDef: 'purchaseorders',
					actionIcon: 'assignment',
					title: 'Lista di carico'
				}
			},
			{
				path: '/orders/supplymanagement',
				beforeEnter: (to, from, next) => canAccess('permission', 'saleorder', next),
				component: SupplyManagement,
				meta: {
					title: trans('supplymanagement')
				},
				props: {
					modelDef: 'supplymanagement',
					actionIcon: 'mdi-package-variant',
					title: 'Gestione Approvvigionamenti'
				}
			},
		],
	},
	{ 
		path: '/orders/saleorders/create',
		name: 'saleorders-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'Nuovo Ordine di vendita'
		},
		props: (route) => ({
			modelDef: 'saleorders',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect,
			footerComponent: 'footer-product-document-table'
		}),
	},
	{ 
		path: '/orders/saleorders/:id/edit',
		name: 'saleorders-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		meta: {
			title: 'Modifica Ordine di vendita'
		},		
		props: (route) => ({
			modelDef:  'saleorders',
			id: parseInt(route.params.id),
			footerComponent: 'footer-product-document-table'
		}),
	},
	{
		path: '/orders/saleorders/:id/',
		beforeEnter: ifAuthenticatedOnline,
		component: SaleorderTabs, 
		props: (route) => ({
			id: parseInt(route.params.id),
		}), 
		children: [
			{
				path: '',
				name: 'saleorders-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Ordine di Vendita'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'saleorders',
					modelClass: 'saleorder',
					activities: true,
					fileuploader: true,
					maillogs: true
				}), 
			},
			{
				path: '/orders/saleorders/:id/ddts',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'ddt', next) },
				component: Crud,
				meta: {
					title: 'DDT di Vendita'
				},				
				props: (route) => ({
					modelDef: 'ddts',
					actionIcon: 'account_circle',
					title: 'DDT di Vendita associati',
					styleClass: 'mb-offset',
					subFilters: {saleorders: parseInt(route.params.id)},
				}),
			},
			{
				path: '/orders/saleorders/:id/purchaseorders',
				beforeEnter: (to, from, next) => canAccess('permission', 'purchaseorder', next),
				component: Crud,
				meta: {
					title: 'Ordini di Acquisto'
				},				
				props: (route) => ({
					modelDef: 'purchaseorders',
					actionIcon: 'account_circle',
					title: 'Ordini di Acquisto associati',
					styleClass: 'mb-offset',
					subFilters: {saleorders: parseInt(route.params.id)},
				}),
			},
		]
	},
	{ 
		path: '/orders/saleorders-process/:id',
		name: 'saleorders-process',
		beforeEnter: ifAuthenticatedOnline,
		component: SaleOrderProcess,
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
	},
	{
		path: '/orders/saleorders-generate-purchaseorders/:id',
		name: 'saleorders-generate-purchaseorders',
		beforeEnter: ifAuthenticatedOnline,
		component: () => import('@/components/modules/orders/SaleorderGeneratePurchaseorders'),
		props: (route) => ({
			id: parseInt(route.params.id)
		}),
	},
	{
		path: '/orders/saleorders-send-mail/:id',
		name: 'saleorders-send-mail',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMail,
		props: (route) => ({
			id: parseInt(route.params.id),
			title: 'Invio email Ordine',
			model_name: 'saleorder',
			route: 'saleorders'
		}),
	},
	{ 
		path: '/orders/purchaseorders/create',
		name: 'purchaseorders-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'purchaseorders',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect,
			footerComponent: 'footer-product-document-table'
		}),
	},
	{ 
		path: '/orders/purchaseorders/:id/edit',
		name: 'purchaseorders-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'purchaseorders',
			id: parseInt(route.params.id),
			footerComponent: 'footer-product-document-table'
		}),
	},
	{ 
		path: '/orders/purchaseorders/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 
		props: (route) => ({
			tabs: [
				{
					to: '/orders/purchaseorders/' + parseInt(route.params.id) + '/',
					text: 'Ordine di acquisto',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'purchaseorders-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Ordine di acquisto'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'purchaseorders',
					modelClass: 'purchaseorder',
					activities: true,
					maillogs: true,
					fileuploader: true
				}), 
			},
		]
	},	
	{ 
		path: '/orders/purchaseorders-process/:id',
		name: 'purchaseorders-process',
		beforeEnter: ifAuthenticatedOnline,
		component: PurchaseOrderProcess,
		props: (route) => ({
			id: parseInt(route.params.id),
			selected: route.params.selected
		}), 
	},
	{
		path: '/orders/purchaseorders-send-mail/:id',
		name: 'purchaseorders-send-mail',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMail,
		props: (route) => ({
			id: parseInt(route.params.id),
			title: 'Invio email Ordine',
			model_name: 'purchaseorder',
			route: 'purchaseorders',
			companyModel: 'suppliers',
			multipleTo: true
		}),
	},
	{ 
		path: '/settingsorders/templates-saleorder/create',
		name: 'templates-saleorder-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-saleorder',
			redirect: route.params.redirect,
			defaultInput: {type: 'saleorder'},			
		}),
	},
	{ 
		path: '/settingsorders/templates-saleorder/:id/edit',
		name: 'templates-saleorder-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-saleorder',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'saleorder'},
		}), 
	},
	{ 
		path: '/settingsorders/templates-order/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingsorders/templates-order/' + parseInt(route.params.id) + '/',
					text: 'Template Ordine Vendita',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-saleorder-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Ordine Vendita'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-saleorder',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},
	{ 
		path: '/settingsorders/templates-purchaseorder/create',
		name: 'templates-purchaseorder-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-purchaseorder',
			redirect: route.params.redirect,
			defaultInput: {type: 'purchaseorder'},			
		}),
	},
	{ 
		path: '/settingsorders/templates-purchaseorder/:id/edit',
		name: 'templates-purchaseorder-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-purchaseorder',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'purchaseorder'},
		}), 
	},
	{ 
		path: '/settingsorders/templates-order/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingsorders/templates-order/' + parseInt(route.params.id) + '/',
					text: 'Template Ordine Acquisto',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-purchaseorder-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Ordine Acquisto'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-purchaseorder',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},
	{ 
		path: '/settingsorders/',
		name: 'settingsorders',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsorders',
					text: 'Ordini di Vendita',
				},
				{
					to: '/settingsorders/purchaseorders',
					text: 'Ordini di Acquisto',
				},
				{
					to: '/settingsorders/picklist',
					text: 'Lista di Prelievo',
				}
			],
		},
		children: [
			{
				path: '/settingsorders/',
				beforeEnter: ifAuthenticatedOnline,
				component: SaleordersSettings,
			},
			{
				path: '/settingsorders/purchaseorders',
				beforeEnter: ifAuthenticatedOnline,
				component: PurchaseordersSettings,
			},
			{
				path: '/settingsorders/picklist',
				beforeEnter: ifAuthenticatedOnline,
				component: PickListSettings,
			},
		],
	},
]